"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayServerCommonAPI = void 0;
const shared_1 = require("@getgreenline/shared");
class WorldpayServerCommonAPI {
    constructor(appSpecificHeaders) {
        this.getResourceFromLocation = ({ requestId, tenantSpecificHeaders, resourceLocation, }) => __awaiter(this, void 0, void 0, function* () {
            const res = yield shared_1.axios.get(resourceLocation, {
                headers: this.getCommonHeaders(requestId, tenantSpecificHeaders),
            });
            if (res.status === 202) {
                const data = {
                    operationRetry: res.headers['operation-retry'],
                    resourceLocation: res.headers['resource-location'],
                };
                return {
                    statusCode: res.status,
                    data,
                };
            }
            return {
                statusCode: res.status,
                data: res.data,
            };
        });
        this.getCommonHeaders = (requestId, tenantSpecificHeaders) => {
            return Object.assign(Object.assign(Object.assign({}, this.appSpecificHeaders), tenantSpecificHeaders), { 'tp-request-id': requestId, 'Content-Type': 'application/json' });
        };
        this.throwError = (error) => {
            var _a;
            // There seem to be 2 types of errors, and I'm not sure what error returns in what format
            const worldpayError = error;
            const message = worldpayError.response ? this.createErrorMessage(worldpayError) : worldpayError;
            throw {
                statusCode: ((_a = worldpayError.response) === null || _a === void 0 ? void 0 : _a.status) || 500,
                message,
            };
        };
        this.createErrorMessage = (worldpayError) => {
            return Object.keys(worldpayError.response.data).includes('_hasErrors')
                ? worldpayError.response.data._errors
                    .map((_error) => _error.developerMessage)
                    .join('\n')
                : worldpayError.response.data.exceptionMessage;
        };
        this.appSpecificHeaders = appSpecificHeaders;
    }
}
exports.WorldpayServerCommonAPI = WorldpayServerCommonAPI;
//# sourceMappingURL=WorldpayServerCommonAPI.js.map